import { getItem } from "./LocalStorage.js";

// Valida un percorso di redirect post-login: deve essere un path relativo
// interno all'app ("/qualcosa"), mai un URL assoluto o protocol-relative
// ("//evil.com", "https://evil.com", "/\evil.com"), per evitare open redirect.
export const isSafeRedirectPath = (path) => {
  if (typeof path !== "string" || path.length === 0) return false;
  if (!path.startsWith("/")) return false; // niente URL assoluti/relative senza slash iniziale
  if (/^\/[\\/]/.test(path)) return false; // blocca "//host" e "/\host" (protocol-relative)
  if (path.includes("://")) return false; // blocca path che incapsulano un altro schema/host
  return true;
};

export const getSafeRedirectPath = (path, fallback = "/") =>
  isSafeRedirectPath(path) ? path : fallback;

// Le route come /programming/destemming/0001 non contengono l'id della winery
// nel path: la risorsa viene risolta solo nel contesto di activeWinery. Per
// poterci tornare dopo il login dobbiamo quindi ricordare anche quale winery
// era attiva quando abbiamo catturato il path, per validarlo dopo la
// (ri)selezione della winery.
export const buildLoginRedirectFrom = (pathname) => ({
  pathname: getSafeRedirectPath(pathname),
  wineryId: getItem("activeWineryId") ?? null,
});

// Il redirect salvato è utilizzabile solo se appartiene alla winery che
// risulterà attiva dopo il login (nessuna wineryId salvata = pagina non
// winery-scoped, sempre valida).
export const isRedirectFromValidForWinery = (from, wineryId) =>
  !from?.wineryId || Number(from.wineryId) === Number(wineryId);
